import React from 'react';
import PropTypes from 'prop-types';

const DeleteIcon = ({className, width, height, fill}) => {
  return (
    <svg className={className} width={width} height={height} viewBox="0 0 12 16" xmlns="http://www.w3.org/2000/svg">
        <title>Delete</title>
        <path fill={fill} fillRule="evenodd" d="M7.467 2.134h-3.2V1.067h3.2v1.067zm3.413 0H8.533V1.067C8.533.257 8.271 0 7.467 0h-3.2C3.528 0 3.2.358 3.2 1.067v1.067H.853c-.471 0-.853.358-.853.8 0 .443.382.8.853.8H10.88c.472 0 .853-.357.853-.8 0-.442-.381-.8-.853-.8zm-7.68 3.2c.295 0 .533.238.533.533l.534 8a.533.533 0 1 1-1.067 0l-.533-8c0-.295.239-.534.533-.534zm2.133.533a.534.534 0 0 1 1.067 0v8a.533.533 0 1 1-1.067 0v-8zm2.667 0a.533.533 0 1 1 1.067 0l-.534 8a.534.534 0 0 1-1.066 0l.533-8zm-6.372 9.047S1.867 16 3.093 16H8.64a1.453 1.453 0 0 0 1.465-1.086L11.2 4.267H.533l1.095 10.647z"/>
    </svg>
  )
}

DeleteIcon.defaultProps = {
  className: '',
  width: '12px',
  height: '16px',
  fill: '#666'
}

DeleteIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string
}

export default DeleteIcon;